export default __webpack_public_path__ + "static/media/rubik-v12-latin-800.2e4dad83.ttf";